/**
 * Module dependencies.
 */

import { StepPageConfig, StepPageProps } from 'src/types/advisor';

/**
 * Export `stepsKeys`.
 */

export const stepsKeys = {
  balloons: 'balloons',
  contactForm: 'contactForm',
  gasContentSlider: 'gasContentSlider',
  mockedBalloons: 'mockedBalloons',
  mockedBalloonsResults: 'mockedBalloonsResults',
  refillable: 'refillable',
  results: 'results',
  typeChemical: 'typeChemical',
  typeCylinder: 'typeCylinder',
  typeGas: 'typeGas',
  waterCapacity: 'waterCapacity',
  waterCapacityGasContent: 'waterCapacityGasContent',
  waterCapacityOther: 'waterCapacityOther',
  waterCapacitySlider: 'waterCapacitySlider'
} as const;

/**
 * Export `stepsWithRadios`.
 */

export const stepsWithRadios = [
  stepsKeys.typeCylinder,
  stepsKeys.refillable,
  stepsKeys.waterCapacityGasContent
];

/**
 * Export `stepsWithOtherOption`.
 */

export const stepsWithOtherOption = [
  stepsKeys.waterCapacityOther,
  stepsKeys.typeChemical
];

/**
 * Export `balloonsOptions`.
 */

export const balloonsOptions = [30, 50];

/**
 * Export `waterCapacityGasContentOptions`.
 */

export const waterCapacityGasContentOptions = {
  gasContent: 'gasContent',
  waterCapacity: 'waterCapacity'
};

/**
 * Export cosnt `waterCapacityOtherOptions`.
 */

export const waterCapacityOtherOptions = ['9.5', '12'];

/**
 * Export `stepsWithTranslationSidebar`.
 */

export const stepsWithTranslationSidebar = [
  stepsKeys.contactForm,
  stepsKeys.refillable,
  stepsKeys.typeChemical,
  stepsKeys.typeCylinder,
  stepsKeys.typeGas,
  stepsKeys.waterCapacityGasContent
];

/**
 * Export `stepPageConfig`.
 */

export const stepPageConfig = (props: StepPageProps): StepPageConfig => {
  const {
    filterKey,
    hasTranslatedOptions = true,
    isLastStep,
    stepIndex,
    stepKey,
    stepOptions
  } = props;

  return {
    description: `advisor:steps.${stepKey}.description`,
    filterKey,
    hasTranslatedOptions,
    isLastStep: isLastStep ?? false,
    pageIndex: stepIndex,
    pageKey: stepKey,
    ...(stepOptions && { options: stepOptions }),
    title: `advisor:steps.${stepKey}.title`
  };
};
